module.exports = {"210502001":"南地街道","210502002":"工人街道","210502003":"平山街道","210502004":"东明街道","210502005":"崔东街道","210502007":"站前街道","210502008":"千金街道","210502010":"北台街道","210502011":"桥头街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210502.json
// module id = 491
// module chunks = 0